function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "publish-24px_3_",
  "data-name": "publish-24px (3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1353",
  "data-name": "Path 1353",
  d: "M0,0H24V24H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1356",
  "data-name": "Path 1356",
  d: "M5.325,4h13.35A.326.326,0,0,1,19,4.325v1.35A.326.326,0,0,1,18.675,6H5.325A.326.326,0,0,1,5,5.675V4.325A.326.326,0,0,1,5.325,4ZM11.77,7.23,5.555,13.445a.325.325,0,0,0,.23.555h2.89A.326.326,0,0,1,9,14.325v4.613A1.061,1.061,0,0,0,10.062,20h3.876A1.061,1.061,0,0,0,15,18.938V14.325A.326.326,0,0,1,15.325,14h2.89a.325.325,0,0,0,.23-.555L12.23,7.23A.325.325,0,0,0,11.77,7.23ZM13,12v5.675a.326.326,0,0,1-.325.325h-1.35A.326.326,0,0,1,11,17.675V12H9.83l1.94-1.94a.325.325,0,0,1,.46,0L14.17,12Z",
  fill: "#00a0af"
}));

var SvgIconUpload = function SvgIconUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_Upload",
    "data-name": "icon - Upload",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_upload.217387d2.svg";
export { ForwardRef as ReactComponent };